/* eslint-disable prefer-template */
/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Dropdown, Label, Button, Message } from "semantic-ui-react";
import ModalWrapper from "../../common/modals/ModalWrapper";

import { getComplaint } from "../../../graphql/queries";
import { updateComplaint } from "../../../graphql/mutations";
import { closeModal } from "../../../redux/modals/modalReducer";
import { statusOptions } from "../../../services/complaint.data";

export function ModalComplaintStatut({ complaint }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [statutData, setStatutData] = useState("");
  const [statutError, setStatutError] = useState("");
  const handleChangeStatut = (e, { value }) => {
    setStatutData(value);
    setStatutError("");
  };

  const [errorMessage, setErrorMessage] = useState(null);
  const [editComplaint] = useMutation(updateComplaint, {
    refetchQueries: [getComplaint],
    onError: (error) => {
      setErrorMessage("Une erreur technique s'est produite");
      console.error(error.message);
    },
  });

  const handleSubmit = () => {
    try {
      const payload = {
        id: complaint.id,
        userComplaintID: complaint.userComplaintID,
        object: complaint.lastname,
        firstname: complaint.firstname,
        lastname: complaint.lastname,
        phone: complaint.phone,
        company: complaint.company,
        email: complaint.email,
        complaintType: complaint.complaintType,
        description: complaint.description,
        createdAt: complaint.createdAt,
        confirmation: complaint.confirmation,
        statut: statutData,
        responsable: complaint.responsable,
      };

      if (statutData === "") {
        setStatutError("Le statut de la plainte est obligatoire");
        return;
      }

      // alert(JSON.stringify(payload, null, 2));
      editComplaint({
        variables: { input: payload },
      });

      dispatch(closeModal());

      navigate("/dashboard/admin-complaint-view/" + complaint.confirmation, {
        replace: true,
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ModalWrapper size="tiny" header="Statut de la plainte">
      {errorMessage && (
        <Message negative>
          <Message.Header>Erreur !!!</Message.Header>
          <p>
            Nous sommes désolés de ne pas pouvoir récuperer les informations
          </p>
          <p>{errorMessage}</p>
        </Message>
      )}
      <Form
        size="large"
        className="attached fluid segment"
        onSubmit={handleSubmit}
      >
        <Form.Field>
          <b>Statut de la plainte</b>
          <Dropdown
            placeholder="Statut de la plainte"
            name="statut"
            fluid
            selection
            options={statusOptions}
            onChange={handleChangeStatut}
            value={statutData}
          />
          {statutError && (
            <Label basic color="red" pointing>
              {statutError}
            </Label>
          )}
        </Form.Field>

        <Button fluid type="submit" positive content="Affecter" />
      </Form>
    </ModalWrapper>
  );
}
export default ModalComplaintStatut;
